import { IsBoolean, IsEmail, IsNotEmpty, IsOptional, IsString } from 'class-validator';

export class LoginRequestDto {
    @IsNotEmpty({ message: 'Invalid credentials' })
    @IsEmail({}, { message: 'Invalid credentials' })
    email: string;

    @IsNotEmpty({ message: 'Invalid credentials' })
    @IsString({ message: 'Invalid credentials' })
    password: string;

    @IsOptional()
    @IsBoolean({ message: 'Invalid request' })
    rememberMe?: boolean;
}
